// src/accounts/components/AccountAvatar.jsx
//
// Colored initials chip for an Account, giving each row in AccountsPage's
// table (and the topbar switcher) a visual anchor instead of bare text —
// same idea as Connections/components/ProviderIcon.jsx, kept as its own
// small component here since Accounts/Projects and Connections are
// separate features that shouldn't reach into each other's internals.

import PropTypes from "prop-types";

const PALETTE = [
  { bg: "var(--jade-blue-100)", fg: "var(--jade-blue-700)" },
  { bg: "var(--jade-gold-400)", fg: "var(--jade-blue-900)" },
  { bg: "var(--jade-success-100)", fg: "var(--jade-success-700)" },
];

function paletteFor(seed) {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export default function AccountAvatar({ name, initials, size = 36 }) {
  const label = (initials || name || "?").slice(0, 2).toUpperCase();
  const { bg, fg } = paletteFor(name || label);

  return (
    <div
      className="flex items-center justify-center rounded-full font-bold shrink-0"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36), background: bg, color: fg }}
    >
      {label}
    </div>
  );
}

AccountAvatar.propTypes = {
  name: PropTypes.string,
  initials: PropTypes.string,
  size: PropTypes.number,
};
